import {Injectable, inject} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Observable, switchMap} from 'rxjs';
import {LanguageService} from 'src/app/shared/language.service';
import {TranslationDialogComponent, TranslationMap} from './translation-dialog.component';
import {MasterData} from 'src/app/master-data/master-data.model';
import {TranslationSettingsService} from 'src/app/language-selection-dialog/translation-settings.service';

@Injectable({providedIn: 'root'})
export class TranslationDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly languageService = inject(LanguageService);
  private readonly translationSettingsService = inject(TranslationSettingsService);

  open(item: MasterData, entityLabel: string): Observable<TranslationMap | undefined> {
    return this.languageService.loadLanguages().pipe(
      switchMap(() => {
        const selectedLanguages = this.translationSettingsService.selectedLanguages();

        const dialogRef = this.dialog.open(TranslationDialogComponent, {
          width: '600px',
          data: {
            entityLabel,
            languages: selectedLanguages,
            translation: item.translations ?? {}
          }
        });

        return dialogRef.afterClosed();
      })
    );
  }
}
